@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.drawer-background {
  flex: 1;
  display: flex;
  flex-flow: column nowrap;

  background: var(--default--background-color--1);
  overflow: auto;
  scrollbar-gutter: stable both-edges;
}

.drawer-body {
  padding: @space-40 @space-16;
  max-width: 1200px;
  width: 100%;
  align-self: center;
  gap: @space-24;

  // allow room for the calendar dropdown
  margin-bottom: 300px;
}

.title-row {
  gap: @space-16;
}

.drawer-body-title {
  display: flex;
}

.asn-received-icon {
  height: 24px;
  width: 24px;
  color: var(--green-700);
  margin-left: @space-8;
}

.metadata-row {
  display: flex;
  gap: @space-24;
  color: var(--gray-637381);
  padding-bottom: @space-16;
  border-bottom: 1px solid var(--gray-DFE4E8);
}

.pill {
  color: var(--white);
  background-color: var(--gray-818F9C);
}
